import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import reasonCodes from 'config/reason-codes';
import Alert from 'components/ui/tailwind/Alert';
import DropdownButton from 'components/ui/tailwind/DropdownButton';
import _ from 'underscore';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class ShipmentStatusReasonCaptureModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: {},
    };
  }

  onResolve() {
    const { t } = this.props;
    this.props.onResolve(
      this.props.exception._id,
      t('REASON_CAPTURED'),
      this.state.reason,
    );
    this.props.onCancel();
  }

  getSaveButton() {
    const disabled = _.isEmpty(this.state.reason);
    const classNames = classnames({
      'bg-green': true,
      'hover:bg-green-dark': true,
      'text-white': true,
      'py-2': true,
      'px-4': true,
      rounded: true,
      'border-green-darker': true,
      shadow: true,
      'mr-2': true,
      'opacity-50': disabled === true,
      'cursor-not-allowed': disabled === true,
    });
    const { t } = this.props;
    return (
      <button
        type="button"
        disabled={disabled}
        onClick={() => this.onResolve()}
        className={classNames}
      >
        {t('RESOLVE')}
      </button>
    );
  }

  render() {
    const { t } = this.props;
    return (
      <Modal show={this.props.show} onHide={() => this.props.onCancel()} enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('REASON_CAPTURE')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <Alert
              status="red"
              message={t('CUSTOMER_REQUIRE_REASON_FOR_EARLY_PICKUP')}
            />
            <div className="my-3">
              <span>{t('SELECT_REASON_TO_DESCRIBE_SITUATION')}</span>
            </div>
            <div className="flex">
              <div className="w-3/4">
                <DropdownButton
                  onSelect={(reason) => this.setState({ reason })}
                  items={reasonCodes}
                  title={
                    t(this.state.reason.localizationSlug) || t('SELECT_REASON')
                  }
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="mt-1 float-right">
            {this.getSaveButton()}
            <a onClick={() => this.props.onCancel()}>{t('CANCEL')}</a>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

ShipmentStatusReasonCaptureModal.propTypes = {
  onResolve: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default withTranslation()(ShipmentStatusReasonCaptureModal);
